import { Component, Vue, Prop } from "vue-property-decorator";
import { Icon } from "ant-design-vue";
import { mergeClasses } from "@/util/func";

@Component({
	components: {
		Icon
	}
})
export default class Loading extends Vue {
	@Prop({ default: false }) visible: boolean | undefined;
	@Prop() text?: string;
	@Prop() cover?: boolean;
	@Prop() height?: number | string;
	@Prop() className?: string;
	@Prop() iconClassName?: string;

	get divClasses() {
		return mergeClasses("sw-loader", this.cover ? "sw-loader--cover" : "", this.className || "");
	}

	get iconClasses() {
		return mergeClasses("sw-loader__icon", this.iconClassName || "");
	}
}
